// extracted by mini-css-extract-plugin
module.exports = {"loader":"Spinner_loader__1Qkvy","spin":"Spinner_spin__GnwYp","container":"Spinner_container__30pq8"};